import { observer } from 'mobx-react';

// Components
import { Form, Radio } from 'top-component-library';
import { RadioGroup } from './styles';

const RadioInput = ({ button = false, choices, className, id, initialValue, label, name, required = false }) => {
  const Control = button ? Radio.Button : Radio;
  const sortedChoices = choices.slice().sort((a, b) => (a.order < b.order ? -1 : 1));

  return (
    <Form.Item
      className={className}
      id={id}
      initialValue={initialValue}
      label={label}
      name={name}
      rules={[
        {
          required,
          message: 'This is a required field',
          validateTrigger: ['onBlur', 'onChange'],
        },
      ]}
      validateTrigger={['onBlur', 'onChange']}
    >
      <RadioGroup className={button ? 'button' : ''}>
        {sortedChoices.map((choice) => (
          <Control
            key={`${choice.label as string}-${(choice.value as string) || ''}`}
            value={choice.value || choice.label}
          >
            {choice.label}
          </Control>
        ))}
      </RadioGroup>
    </Form.Item>
  );
};

export default observer(RadioInput);
